import { TagIcon } from '../../../../common/ui/icons';
import { useEffect } from 'react';
import TagsList from './tags-list';
import { ListType } from '../../planner-interfaces';
import Actions from '../../../../common/ui/actions';
import CloseAllTagsBtn from './actions/close-all-tags-btn';
import HideFutureTasks from './actions/hide-future-tasks';
import { usePlannerStore } from '../../data/planner-store';

const TagsView = () => {

    const setListType = usePlannerStore(state => state.setListType);

    useEffect(() => {
        setListType(ListType.TagsView);
    }, [setListType]);

    useEffect(() => {
        document.title = 'Tags | Productivity';
    }, []);

    return (
        <div className="flex flex-col flex-1 leading-7 h-screen relative z-50 bg-white w-screen">
            <div className="overflow-auto px-6 py-10 flex-1">

                <div className="xl:w-[800px] max-w-full mx-auto">

                    <div className="mb-4 w-full flex flex-col">

                        <h1 className="text-xl xl:text-3xl border-b border-teal-400 pb-2 flex items-center">
                            <TagIcon classes="mr-4" size={ 35 } color={ '#2E766E' }/>
                            Tags

                            <Actions classes="tags-view__actions">
                                <CloseAllTagsBtn/>
                            </Actions>
                        </h1>

                        {
                            /**
                             * Optional project description here.
                             */
                        }
                    </div>

                    <div className="flex justify-end items-center mb-4">
                        <HideFutureTasks/>
                    </div>

                    <TagsList/>
                </div>

            </div>
        </div>
    )
};

export default TagsView;